import { render, staticRenderFns } from "./update-channel-modal.vue?vue&type=template&id=7e472e62&scoped=true"
import script from "./update-channel-modal.vue?vue&type=script&lang=js"
export * from "./update-channel-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e472e62",
  null
  
)

export default component.exports